@if (!skip()) {
  <div class="outer-container">
    <div
      class="inner-container"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      [class.selected]="isSelectionInside()"
    >
      <div class="caption" [class.active]="isSelected()">
        @switch (true) {
          <!-- @case(!isLink){
          <span class="text level-{{ node().nodeName }}">
            <mat-icon inline *ngIf="node() | nodeIcon as icon">{{ icon }}</mat-icon>
            <span>{{ node().title }}</span>
          </span>
          } -->
          @case (isPublication() && !!node().organization) {
            <a
              class="nav-publication text clickable level-{{ node().nodeName }}"
              (click)="onToggle()"
              [routerLink]="['/search', node().organization, node().id]"
              matRipple
            >
              <app-expand-arrow class="flex-none" [state]="state()" [size]="16" />
              <!-- @if (node() | nodeIcon; as icon) {
                <mat-icon class="flex-none" inline>{{ icon }}</mat-icon>
              } -->
              <span>{{ node().title }}</span>
            </a>
          }
          @case (isDoc()) {
            <a
              class="nav-doc text clickable level-{{ node().nodeName }}"
              (click)="onToggle()"
              [routerLink]="['/library', node().id]"
              [queryParams]="{ page: node().startPage }"
              queryParamsHandling="merge"
              matRipple
            >
              <app-expand-arrow [state]="state()" [size]="16" />
              <!-- @if (node() | nodeIcon; as icon) {
                <mat-icon inline>{{ icon }}</mat-icon>
              } -->
              <span>
                {{ node().title }}
                @if (
                  docType() === DocumentTypes.Amtsblatt &&
                  ((node().startPage !== null && node().startPage !== undefined) ||
                    (node().endPage !== null && node().endPage !== undefined))
                ) {
                  &nbsp; ({{
                    node().startPage !== node().endPage && node().endPage !== null && node().endPage !== undefined
                      ? ("LIBRARY.NAVIGATION.PAGES" | translate: { start: node().startPage, end: node().endPage })
                      : ("LIBRARY.NAVIGATION.PAGE" | translate: { page: node().endPage || node().startPage })
                  }})
                }
              </span>
            </a>
          }
          @case (isChapter()) {
            <a
              class="nav-chapter text clickable level-{{ node().nodeName }}"
              (click)="onToggle()"
              [routerLink]="['/library', docId()]"
              [queryParams]="{ page: node().startPage }"
              queryParamsHandling="merge"
              matRipple
            >
              <app-expand-arrow [state]="state()" [size]="16" />
              <span>{{ node().title }}</span>
            </a>
          }
          @default {
            @if (mayNavigate()) {
              <a
                class="nav-default text clickable level-{{ node().nodeName }}"
                (click)="onToggle()"
                [routerLink]="!mayNavigate() ? null : ['/library', node().id]"
                matRipple
              >
                <app-expand-arrow [state]="state()" [size]="16" />
                <!-- @if (node() | nodeIcon; as icon) {
                  <mat-icon inline>{{ icon }}</mat-icon>
                } -->
                <span>{{ node().title }}</span>
              </a>
            } @else {
              <button mat-button class="nav-default text clickable level-{{ node().nodeName }}" (click)="onToggle()" matRipple>
                <app-expand-arrow [state]="state()" [size]="16" />
                <!-- @if (node() | nodeIcon; as icon) {
                  <mat-icon inline>{{ icon }}</mat-icon>
                } -->
                <span>{{ node().title }}</span>
              </button>
            }
          }
        }
        @if (canEdit()) {
          @if (node().hidden) {
            <button mat-icon-button disabled class="small-icon-btn">
              <mat-icon inline class="visbility-icon">visibility_off</mat-icon>
            </button>
          }
          <a mat-icon-button [routerLink]="['/editor', node().id]" class="small-icon-btn">
            <mat-icon inline color="warn">edit</mat-icon>
          </a>
        }
      </div>
      @if (expandable() && (!isLink() || state() === "expanded")) {
        <div animate.enter="v-expand-in" animate.leave="v-expand-out" (animationend)="onAnimationDone($event)" class="children-container">
          <div class="children">
            <ng-container *ngTemplateOutlet="children" />
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="children" />
}

<ng-template #children>
  @for (child of node().children; track child.id) {
    <app-library-navigation-node [docId]="docId()" [docType]="docType()" [pathInfo]="pathInfo()" [canEdit]="canEdit()" [node]="child" />
  }
</ng-template>
